export default __webpack_public_path__ + "static/euBadge-98dba3173d521126c30949135e755e0a.jpg";